var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#B30000",
    fillOpacity: 0.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_59660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6081 25.4072L15.5554 25.2452C15.4145 24.7172 15.4149 24.1612 15.5567 23.6324C15.8575 22.9488 15.9734 22.1994 15.8931 21.4588C15.7569 20.9189 15.5452 20.3879 15.4066 19.8409C14.8263 17.1863 16.7951 14.5837 19.2344 13.7911L19.3054 13.7681C21.7872 12.9616 24.846 13.9307 25.951 16.4148C26.1723 16.9271 26.3013 17.4928 26.5155 18.0074C26.8827 18.6561 27.4177 19.1949 28.0653 19.5681C28.5015 19.9036 28.835 20.3535 29.0285 20.8675L29.0811 21.0296C29.3138 21.7311 29.2831 22.4937 28.9947 23.1764C28.6077 24.0004 27.9307 24.6556 27.092 25.0175C24.6716 26.1623 22.1144 26.9932 19.4833 27.4897C18.6 27.68 17.6785 27.5448 16.8902 27.1094C16.2684 26.7168 15.8126 26.1116 15.6081 25.4072Z",
    fill: "#B30000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.5965 27.0269C24.0816 27.1553 23.6818 27.3242 23.2705 27.4578C22.8603 27.5833 22.467 27.7582 22.0991 27.9786C21.784 28.1667 21.4747 28.4697 21.6007 28.8572C21.7581 29.2201 22.0712 29.4929 22.4537 29.6005C23.2095 29.8662 24.0407 29.828 24.771 29.494C25.4908 29.2001 26.0413 28.6009 26.271 27.8616C26.407 27.4807 26.212 27.0627 25.8323 26.9214C25.418 26.8628 24.9954 26.8989 24.5965 27.0269Z",
    fill: "#B30000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_59660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9.25781 15.282) rotate(-18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3d6ede0243f0920f84ed1859b068da78.svg";
export { ForwardRef as ReactComponent };